import React from 'react';

import { Suggestions, Inner, Items } from './styles';

type Props = {
  children: React.ReactNode;
  containerRef: React.Ref<HTMLUListElement>;
};

export const SuggestionBox = (props: Props) => {
  const { children, containerRef } = props;

  return (
    <Suggestions>
      <Inner>
        <Items
          ref={containerRef}
          data-test="SearchSuggestionsBox"
          id="overlaySearchResults"
          aria-expanded="true"
        >
          {children}
        </Items>
      </Inner>
    </Suggestions>
  );
};
